<template>

    <div class="main--navigation">
        <div class="container">


            <ul>
                <li class="main--navigation-logo">
                    <SvgLogo />
                </li> 
                <li>
                    <a v-if="isLoggedIn" href="#" @click.prevent="showUserInfoFromMenu" class="paddingx-5">
                        <button class="button2">
                            <span>{{ truncatedUserName }}</span>
                            
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>
                                <path d="M8.256 14a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Z"/>
                            </svg>
                        </button>
                    </a>
                    <a v-else href="#" @click.prevent="showLoginWindow" class="paddingx-5">
                        <button class="button2">
                            <span>Iniciar sesión</span>
                            
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>
                                <path d="M8.256 14a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Z"/>
                            </svg>
                        </button>
                    </a>
                </li>
                <li>
                    <a href="#" @click.prevent="openBuyTokens">
                        <button class="button1">
                            <span>Fichas</span>
                            <svg class="token-ficha--svg" width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000">
                                <g stroke="none" stroke-width="1" fill-rule="evenodd">
                                    <g id="token-ficha">
                                        <path d="M20,40 C8.954305,40 0,31.045695 0,20 C0,8.954305 8.954305,0 20,0 C31.045695,0 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 Z M20,36 C28.836556,36 36,28.836556 36,20 C36,11.163444 28.836556,4 20,4 C11.163444,4 4,11.163444 4,20 C4,28.836556 11.163444,36 20,36 Z" id="token-combi"></path>
                                        <polygon id="Star" points="19.839263 28 11.9041621 32.3262379 13.4196315 23.163119 7 16.6737621 15.8717125 15.336881 19.839263 7 23.8068134 15.336881 32.6785259 16.6737621 26.2588945 23.163119 27.7743639 32.3262379"></polygon>
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </a>
                </li>
                <li>
                    <a href="#" @click.prevent="showSlideMenu">
                        <button class="button4">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
                            </svg>
                        </button>
                    </a>
                </li>
            </ul>

        </div>
    </div>

</template>

<script>
import SvgLogo from './SvgLogo.vue'
export default {
    data() {
        return {
            createdCards: null,
            maxCharacters: 7,
        }
    },

    components: {
        SvgLogo
    },

    methods: {
        showUserInfoFromMenu() {
            this.$emit('showUserInfoFromMenu')
        },
        showLoginWindow() {
            this.$emit('showLoginWindow')
        },
        openBuyTokens() {
            this.$emit('openBuyTokens')
        },
        showSlideMenu() {
            this.$emit('showSlideMenu')
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        }, 
        isLoggedIn() {
            return this.$store.state.loggedIn
        },
        truncatedUserName() {
            if (this.user.userName.length <= this.maxCharacters) {
                return this.user.userName;
            } else {
                return this.user.userName.substring(0, this.maxCharacters) + '_';
            }
        }
    }
}
</script>

<style lang="less">

 .main--navigation {
    margin-bottom: 4rem;
    ul {
        border-radius: var(--radius_global);
        background: var(--medium_blue);
        padding: 1rem;
        border: 2px solid var(--light_blue);
        display: flex;
        justify-content: flex-end;
        align-items: center;
        background: none;
        border: 0;

        li {

            a {
                text-decoration: none;
                font-weight: 700;
                color: var(--blue_main);
                font-size: 0.8rem;

                &.userItem--nav {
                    display: inline-block;
                    padding: 0.75rem;
                    margin: 0 1rem;
                    background: #efefef;
                    border-radius: var(--radius_global)
                }

                svg, span {
                    display: inline-block;
                    vertical-align: middle;
                }
                

            }
        }
    }

 }

 button.button-gradient {
    background: var(--button_gradient_green);
    color: #fff;
    text-transform: capitalize;
    font-family: var(--comic-font);
    text-shadow: 0 1px 3px black;
 }

 .main--navigation-logo {
    flex: 1;

    svg {
        display: block;
        width: 100%;
        max-width: 150px;
        height: auto;
    }
 }

 #fut-logo--small {
    display: none;
 }

 @media(max-width: 768px) {
    #fut-logo {
        display: none;
    }

    #fut-logo--small {
        display: block;
        max-width: none;
        max-height: 38px;
        width: auto;
        height: auto;
    }

    .main--navigation ul li a span {
        display: none;
    }

    .token-ficha--svg {
        margin-left: 0!important;
    }
 }

 .paddingx-5 {
    padding: 0 1rem 0 0;
 }

</style>